export default "__VITE_ASSET__knjO$YId__"